const globalStyleId = 'gs-button';
const defaultSelector = {
  selector: '#{mID}',
};
export default {
  defaultClass: 'gf_gs-button-check-button gf_gs-button---large',
  settingGroups: {
    [globalStyleId]: {
      'font-size': {
        ...defaultSelector,
        inherit: 'button.textStyleValue.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      font: {
        ...defaultSelector,
        inherit: 'button.textStyleValue.fontFamily',
        cssAttr: 'font-family',
      },
      'font-style': {
        ...defaultSelector,
        inherit: 'button.textStyleValue.fontStyle',
        cssAttr: 'font-style',
      },
      'font-style-weight': {
        ...defaultSelector,
        inherit: 'button.textStyleValue.fontWeight',
        cssAttr: 'font-weight',
      },
      'font-style-decoration': {
        ...defaultSelector,
        inherit: 'button.textStyleValue.decoration',
        cssAttr: 'text-decoration',
      },
      'button-color': {
        ...defaultSelector,
        inherit: 'button.backgroundColor.origin',
        cssAttr: 'background-color',
      },
      color: {
        ...defaultSelector,
        inherit: 'button.textColor.origin',
        cssAttr: 'color',
      },
      buttonHover: {
        ...defaultSelector,
        inherit: 'button.buttonHover',
      },
      'button-color-hover': {
        selector: '#{mID}:hover',
        inherit: 'button.backgroundColor.hover',
        cssAttr: 'background-color',
      },
      'color-hover': {
        selector: '#{mID}:hover',
        inherit: 'button.textColor.hover',
        cssAttr: 'color',
      },
      'border-style': {
        ...defaultSelector,
        inherit: 'button.borderStyleValue.style',
        cssAttr: 'border-style',
      },
      'border-color': {
        ...defaultSelector,
        inherit: 'button.borderStyleValue.color',
        cssAttr: 'border-color',
      },
      'border-width': {
        ...defaultSelector,
        inherit: 'button.borderStyleValue.thickness',
        cssAttr: 'border-width',
      },
      'border-top-width': {
        ...defaultSelector,
        inherit: 'button.borderStyleValue.thickness',
        cssAttr: 'border-top-width',
      },
      'border-right-width': {
        ...defaultSelector,
        inherit: 'button.borderStyleValue.thickness',
        cssAttr: 'border-right-width',
      },
      'border-bottom-width': {
        ...defaultSelector,
        inherit: 'button.borderStyleValue.thickness',
        cssAttr: 'border-bottom-width',
      },
      'border-left-width': {
        ...defaultSelector,
        inherit: 'button.borderStyleValue.thickness',
        cssAttr: 'border-left-width',
      },
      'border-radius': {
        ...defaultSelector,
        cssAttr: 'border-radius',
      },
      'border-top-left-radius': {
        ...defaultSelector,
        inherit: 'button.cornerStyleValue.top',
        cssAttr: 'border-top-left-radius',
      },
      'border-top-right-radius': {
        ...defaultSelector,
        inherit: 'button.cornerStyleValue.right',
        cssAttr: 'border-top-right-radius',
      },
      'border-bottom-right-radius': {
        ...defaultSelector,
        inherit: 'button.cornerStyleValue.bottom',
        cssAttr: 'border-bottom-right-radius',
      },
      'border-bottom-left-radius': {
        ...defaultSelector,
        inherit: 'button.cornerStyleValue.left',
        cssAttr: 'border-bottom-left-radius',
      },
      'box-shadow-angle': {
        ...defaultSelector,
        inherit: 'button.dropShadowValue.angle',
        cssAttr: 'box-shadow',
      },
      'box-shadow-distance': {
        ...defaultSelector,
        inherit: 'button.dropShadowValue.distance',
        cssAttr: 'box-shadow',
      },
      'box-shadow-blur': {
        ...defaultSelector,
        inherit: 'button.dropShadowValue.blur',
        cssAttr: 'box-shadow',
      },
      'box-shadow-spread': {
        ...defaultSelector,
        inherit: 'button.dropShadowValue.size',
        cssAttr: 'box-shadow',
      },
      'box-shadow-color': {
        ...defaultSelector,
        inherit: 'button.dropShadowValue.color',
        cssAttr: 'box-shadow',
      },
    },
  },
};

export const DYNAMIC_BUTTON_SETTING = [
  {
    gsId: globalStyleId,
    gsSettingGroup: 'Button',
    isRenderColumn: true,
    prefix: 'gf_gs-button-',
    typeSetting: 'button',
    buttonKey: 'check-button',
    hideColumns: [],
    selectorSupportModifyStyle: '#{mID} .shopify-payment-button__button',
    // hideColumns: ["Border", "Corner"]
  },
];
